import React, { useState, useEffect } from "react";

export const LoadingOverlay = ({ 
    active, 
    initialText = "Memuat data accurate...", 
    transitionText = "Memuat data datadigi...", 
    delay = 1500,
    subText = "Mohon tunggu sebentar"
}) => {
    const [loadingText, setLoadingText] = useState(initialText);

    useEffect(() => {
        if (!active) return;

        setLoadingText(initialText);

        const timer = setTimeout(() => {
            setLoadingText(transitionText);
        }, delay);

        return () => clearTimeout(timer);
    }, [active, initialText, transitionText, delay]);

    if (!active) return null;

    return (
        <div className="absolute inset-0 flex flex-col items-center justify-center bg-white/85 backdrop-blur-sm z-10 gap-4">
            <style>{`
                @keyframes custom-spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                @keyframes pulse-glowing {
                    0%, 100% { transform: scale(0.95); opacity: 0.8; }
                    50% { transform: scale(1.05); opacity: 1; }
                }
            `}</style>
            <div className="relative w-14 h-14 flex items-center justify-center">
                {/* Outer animated ring */}
                <div 
                    className="absolute w-full h-full rounded-full border-[3px] border-transparent border-t-sky-500 border-b-sky-500"
                    style={{
                        animation: 'custom-spin 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
                    }} 
                />
                {/* Inner ring spinning in reverse */}
                <div 
                    className="absolute w-[75%] h-[75%] rounded-full border-[3px] border-transparent border-l-sky-400 border-r-sky-400 opacity-70"
                    style={{
                        animation: 'custom-spin 0.8s linear infinite reverse',
                    }} 
                />
                {/* Center pulsing core dot */}
                <div 
                    className="w-2.5 h-2.5 bg-sky-500 rounded-full shadow-[0_0_8px_#0ea5e9]"
                    style={{
                        animation: 'pulse-glowing 1.5s ease-in-out infinite'
                    }} 
                />
            </div>
            <div className="flex flex-col items-center gap-1">
                <span 
                    className="text-sky-500 font-semibold text-[13px] tracking-[-0.01em] transition-all duration-300"
                    style={{
                        animation: 'pulse-glowing 2s infinite'
                    }}
                >
                    {loadingText}
                </span>
                {subText && (
                    <span className="text-[11px] text-slate-400 font-normal">
                        {subText}
                    </span>
                )}
            </div>
        </div>
    );
};
